import { useTranslation } from "react-i18next";
import { Heading, YStack } from "tamagui";

import CustomCard from "../../components/CustomCard";

export const SensorManuals = () => {
  const { t } = useTranslation();

  return (
    <YStack gap="$4">
      <Heading size="$14" fontSize="$14" $xs={{ fontSize: "$12" }}>
        {t("sidebar.sensorManuals")}
      </Heading>
      <YStack gap="$3.5">
        <CustomCard
          label={t("sensorManuals.baseStation")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.leakDetector")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.waterQualityMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.airQualityMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.powerMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.hvacAirhandlerMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
        <CustomCard
          label={t("sensorManuals.hvacCondenserMonitor")}
          routePath="https://www.hghomeguardian.com/manualscomingsoon"
        />
      </YStack>
    </YStack>
  );
};
export default SensorManuals;
